/**
 * Additional flashlight variants for style stix products.
 * impemented: snippets/product-page-get-info-clear-stix.liquid
 */
function formatMoney(cents, format) {
    const moneyFormat = '${{amount}}';

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

function updateLabelText(amount = 0){
  const labelPrice = document.querySelector("[data-js-additional-product-label-price]")
      if(!labelPrice){
         console.log("Additional product, can't found DOM label price")
          return;
      }

      const price = formatMoney(Number(amount), '{{ amount }}')
      labelPrice.innerText = `$${price}`
}

function isMobile() {
    let match = window.matchMedia || window.msMatchMedia;
    if(match) {
        let mq = match("(pointer:coarse)");
        return mq.matches;
    }
    return false;
}

document.addEventListener("DOMContentLoaded", function () {
  const productImgs = document.querySelectorAll(
    "[data-js-additional-product-item-img]"
  ); 

  const modalBtn = document.querySelector("[data-js-additional-product-modal-trigger]")
  const modalContent = document.querySelector("[data-js-additional-product-modal]")
  const modalClose = document.querySelector("[data-js-additional-product-modal-close]")
  

  if (productImgs.length === 0 ) {
    console.log("Additional product, can't found productImgs DOM elements.");
    return;
  }

  if(!modalBtn || !modalContent || !modalClose) {
    console.log("Additional product, can't found modal DOM elements.");
    return;
  }

  

  productImgs.forEach(img => {
    img.addEventListener('click', (e)=>{
      const { jsAdditionalProductId, jsAdditionalProductPrice } = e.target.dataset;
      console.log( {jsAdditionalProductPrice });

      if(!jsAdditionalProductPrice ||  !jsAdditionalProductId){
        console.log("Additional product, can't found DOM container product price or variant id")
        return;
      }
      
      // remove class from previous selected
      const prevImg = document.querySelectorAll(
        "[data-js-additional-product-item-img].active"
      )

      if(prevImg.length !== 0){
        prevImg.forEach(img => img.classList.remove("active"))
      }
      
      // add class to selected item
      e.target.classList.toggle("active")

      
      updateLabelText(jsAdditionalProductPrice)

      // light up variant that is going to be added to from
      // snippets/product-page-get-info-clear-stix.liquid
      const additionalProduct = document.querySelector("[data-js-selected-additional-product-id]")
      if(!additionalProduct){
         console.log("Additional product, can't found DOM form light up form variant")
        return;
      }
      additionalProduct.value = jsAdditionalProductId
      console.log("added")

    })
  })

  // event type based on mobile or dekstop device
  const eventType = isMobile() ? 'click' : 'mouseenter'
  console.log({eventType})

  modalBtn.addEventListener(eventType, ()=>{
    modalContent.showModal()
  })


  modalClose.addEventListener("click", ()=> {
	modalContent.setAttribute("data-closing", "")
	modalContent.addEventListener("animationend", ()=>{
		modalContent.removeAttribute("data-closing")
		modalContent.close()
	}, {once: true})	
  })

  // backdrop
  modalContent.addEventListener('click', (e)=>{
    if(e.target.nodeName === "DIALOG"){
        modalContent.close()
    }	
  })
  
});
